import TabsHeader from './TabsHeader';
import './TabsHeader.scss';

export default TabsHeader;
